<template>
    <div class="d-flex flex-fill flex-column" :class="students && students.length ? 'meeting-students-main' : ''" v-if="meeting">
        <div v-if="!students || students.length === 0" style="padding: 30px;">No students have been attached to this meeting.</div>
        <div v-else class="d-flex flex-column flex-fill">
            <div class="d-flex col-header flex-shrink-0">
                <div class="headline left-col">
                    <div class="meetings-student-list-filter">
                        <v-text-field
                            ref="filterField"
                            id="filter_field"
                            class="filter-field"
                            placeholder="Filter Students"
                            v-model="filter"
                            solo flat
                            hide-details
                            clearable
                            prependInnerIcon="far fa-search"
                        />
                    </div>
                </div>
                <v-tabs height="53px" v-model="tab" class="ec-collection-tabs meeting-tabs" style="position: relative; bottom: -6px;" show-arrows>
                    <v-tab v-for="tab in tabs" class="small-tab small-tab-all">{{ tab.name }}</v-tab>
                </v-tabs>
            </div>
            <div class="d-flex flex-fill no-scroll">
                <div class="d-flex left-col flex-column flex-shrink-0">
                    <div class="lower-scroll">
                        <v-list dense class="pa-0 ma-0">
                            <v-list-item
                                v-for="stdnt in filteredStudents"
                                :key="`meeting-student-${stdnt.id}`"
                                @click="studentId = stdnt.student_id"
                                class="px-1 py-0 d-flex"
                                :class="{ 'selected-student': stdnt.student_id === studentId }"
                                dense
                                style="height: 50px; border-bottom: 1px solid #ECEDF1;"
                            >
                                <div
                                    v-if="stdnt.img && stdnt.img.styles && !stdnt.img.top_secret"
                                    class="ma-2"
                                    style="border-radius: 50%; display: inline-block; width:31px; height:26px; overflow:hidden;"
                                    :title="stdnt.student_full_name"
                                >
                                    <div :style="stdnt.img.styles"></div>
                                </div>
                                <v-img
                                    v-else
                                    class="ma-2"
                                    :src="defaultStudentImg"
                                    width="26"
                                    maxWidth="26"
                                    height="26"
                                    maxHeight="26"
                                />
                                <div class="d-flex justify-space-between align-center" style="width: 100%;">
                                    <span style="font-size: 12px">{{ stdnt.student_full_name }}</span>
                                    <div class="d-flex">
                                        <div @click="addTag(stdnt.student_id)" class="pr-2">
                                            <v-icon class="far fa-tag"></v-icon>
                                        </div>
                                        <div @click="addComment(stdnt.student_id)" class="pr-2">
                                            <v-icon class="far fa-comment"></v-icon>
                                        </div>
                                    </div>
                                </div>
                            </v-list-item>
                        </v-list>
                    </div>
                </div>
                <div class="flex-fill flex-column flex-grow-1 flex-shrink-1" style="background: #F5F6F8;" v-if="student && currentTab">
                    <div v-if="currentTab.name && !['Comments','Tags'].includes(currentTab.name)" class="flex-fill px-5 pt-5 d-flex" style="height: 60px; justify-content: flex-end">
                        <div class="align-self-center" v-if="currentTab.name !== 'Thresholds'">
                            <fe-remote-combo
                                class="ma-2"
                                :url="$models.getUrl('schoolYear', 'read')"
                                rootProperty="years"
                                v-model="schoolYear"
                                hideDetails
                                data-test="meetings-student-school-year-dropdown"
                                aria-label="Meetings School Year Dropdown"
                            />
                        </div>
                    </div>
                    <div class="px-4 py-3 lower-scroll" :key="`meetings-${meeting.id}-students-${student.student_id}-year-${schoolYear.id}`">
                        <interventions v-if="currentTab.name === 'Interventions'" :params="{ student_id: student.student_id, school_year_id: schoolYear.id }"/>
                        <score-group
                            :student="studentWithSelectedYear"
                            v-else-if="currentTab.name === 'Assessments'"
                            style="width: 100%;"
                            @score-click="doScoreClick"
                            fromMeetings
                        />
                        <fe-card
                            class="alt-card"
                            headerText="Incidents"
                            v-else-if="currentTab.name === 'Incidents'"
                            style="width: 100%;"
                        >
                            <template v-slot:body>
                                <big-five
                                    :params="bigFiveParams"
                                />
                            </template>
                        </fe-card>
                        <fe-card
                            class="alt-card flex-fill flex-column"
                            headerText="Student Attendance"
                            v-else-if="currentTab.name === 'Attendance'"
                            style="width: 100%;"
                        >
                            <template v-slot:body><attendance :params="{ student_id: student.student_id, school_year_id: schoolYear.id }" /></template>
                        </fe-card>
                        <smartforms
                            :schoolYearId="schoolYear.id"
                            :studentId="student.student_id"
                            v-else-if="currentTab.name === 'smartFORMS'"
                        />
                        <fe-card
                            class="alt-card"
                            headerText="Student Comments"
                            v-else-if="currentTab.name === 'Comments'"
                            style="width: 100%;"
                        >
                            <template v-slot:body><message ref="comments" dense messageModel="studentComments" :params="{ student_id: student.student_id }" :key="`mtg-stdnt-comments-${student.student_id}`" /></template>
                        </fe-card>
                        <fe-card
                            class="alt-card flex-fill flex-column"
                            headerText="Student Tags"
                            v-else-if="currentTab.name === 'Tags'"
                            style="width: 100%;"
                        >
                            <template v-slot:body><tag-list ref="tags" class='flex-fill' @addTagClick="addTag(student.student_id)" :params="{ student_id: student.student_id }" :key="`mtg-stdnt-tags-${student.student_id}`" /></template>
                        </fe-card>
                        <div
                            v-else-if="currentTab.name === 'Thresholds'"
                            style="width: 100%;"
                        >
                            <thresholds-table ref="thresholds" class='flex-fill' :params="{ student_id: student.student_id }" meeting />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <fe-dialog
            title="Student Comments"
            width="800"
            v-if="messageDialog"
            @accept="() => $refs.msgCreate.doSubmit()"
            @close="messageDialog=null"
            persistent
            dismissButtonText="Cancel"
            acceptButtonText="Create"
            :retain-focus="false"
        >
            <message
                ref="msgCreate"
                @created="messageDialog=null"
                dense
                create-only
                hide-submit
                :params="messageDialog"
            />
        </fe-dialog>
    </div>
</template>

<script>
import defaultStudentImg from '@/assets/images/default-student-img.png'
    import {mapState} from 'vuex'
    import Interventions from '@/components/modules/meetings/workspace/students/Interventions'
    import ScoreGroup from '@/components/modules/studentprofile/ScoreGroup'
    import BigFive from '@/components/modules/incidents/BigFive'
    import Attendance from '@/components/modules/attendanceReporting/StudentAttendance'  // EC-2457
    import Smartforms from '@/components/modules/smartforms/List'
    import Message from '@/components/common/Message'
    import TagList from '@/components/modules/studentprofile/TagList'
    import ThresholdsTable from '@/components/modules/studentprofile/ThresholdsTable'

    export default {
        name: 'Students',
        props: {
            meeting: { type: Object, required: true }
        },
        components: {
            Interventions,
            ScoreGroup,
            BigFive,
            Attendance,
            Smartforms,
            Message,
            TagList,
            ThresholdsTable
        },
        data () {
            return {
                defaultStudentImg,
                messageDialog: null,
                filter: '',
                selectedTab: null,
                selectedYear: null,
                selectedYearName: null,
                studentId: null,
                tabs: [
                    { name: 'Interventions', path: '#' },
                    { name: 'Assessments', path: '#' },
                    { name: 'Incidents', path: '#' },
                    { name: 'Attendance', path: '#' },
                    { name: 'smartFORMS', path: '#' },
                    { name: 'Comments', path: '#' },
                    { name: 'Tags', path: '#' },
                ],
                imageObjs: null,
            }
        },
        mounted() {
            if (this.filteredStudents.length > 0) {
                // Default to first student in list
                this.studentId = this.filteredStudents[0].student_id
            }
        },
        computed: {
            ...mapState('global', ['currentYear']),
            schoolYear: {
                get () { return this.selectedYear || this.currentYear },
                set (v) { this.selectedYear = v }
            },
            tab: {
                get () { return this.selectedTab !== null ? this.selectedTab : 0 },
                set (v) { this.selectedTab = v }
            },
            currentTab () {
                return this.tabs[this.tab]
            },
            students () {
                return this.meeting.dashboard_meeting_students?.map(student => {
                    if (this.imageObjs) {
                        let img = this.imageObjs.images.find(itm => itm.id === student.student_id)
                        return img
                            ? Object.assign({}, student, { img: img })
                            : student
                    } else {
                        return student
                    }
                })
            },
            filteredStudents () {
                return (this.students && this.students.length) ? this.students.filter(stdnt => {
                    return (this.filter && this.filter.trim().length > 0)
                        ? (stdnt.student_full_name.toLowerCase().indexOf(this.filter.trim().toLowerCase()) > -1)
                        : true
                }) : []
            },
            student () {
                return (this.studentId)
                    ?  this.students.find(student => student.student_id === this.studentId)
                    : null
            },
            studentWithSelectedYear () {
                return (this.studentId)
                    ?  Object.assign(this.student, {
                        school_year_id: this.schoolYear.id,
                        school_year_name: this.schoolYear.name
                    })
                    : null
            },
            bigFiveParams () {
                return {
                    student_id: this.studentId,
                    school_year_id: this.schoolYear.id,
                    incident_behavior_type_id: null
                }
            },
        },
        methods: {
            addComment (student_id) {
                this.messageDialog = {
                    student_id: student_id,
                    school_year_id: this.schoolYear.id
                }
            },
            addTag (student_id) {
                let me = this
                this.$store.commit('global/tagStudents', {
                    show: true,
                    students: [{ student_id: student_id }],
                    callback() {
                        if (me.$refs.tags && me.$refs.tags.reload) me.$refs.tags.reload()
                    }
                })
            },
            fetchStudentImages () {
                if (!this.meeting || !this.meeting.dashboard_meeting_students) return
                let ids = this.meeting.dashboard_meeting_students.map(student => student.student_id)
                if (ids && ids.length) {
                    this.$fetchStudentImages(ids, 26).then((obj) => this.imageObjs = obj)
                }
            },
            doScoreClick(rec, title) {
                this.$store.commit('global/addDockableWindow', {
                    name: title,
                    data: rec,
                    component: 'assessment-history',
                    attrs: {
                        studentId: rec.student_id,
                        subCategoryId: rec.sub_category_id,
                        dataPointScoreId: rec.data_point_score_id
                    }
                })
            },
        },
        watch: {
            meeting: {
                handler(v) {
                    if (v && v.id) {
                        this.fetchStudentImages()
                    }
                },
                immediate: true
            },
            messageDialog (v) {
                if (!v && this.$refs.comments?.$refs.crud) this.$refs.comments.$refs.crud.read()
            },
            studentId(v) {
                if (v) {
                    let params = '&student_id=' + v
                    this.$axios.get(this.$models.getUrl('studentThresholdGroupResult', 'read') + params)
                        .then(resp => {
                            let thresholds = this.tabs.some(tab => tab.name === 'Thresholds')
                            if (resp.data.threshold_group_result.length && !thresholds) {
                                this.tabs.push({name: 'Thresholds', path: '#'})
                            } else if (!resp.data.threshold_group_result.length && thresholds) {
                                this.tabs = this.tabs.slice(0, this.tabs.length - 1)
                                if (this.currentTab && this.currentTab.name === 'Thresholds') {
                                    this.selectedTab = this.tabs.findIndex(tab => tab.name === 'Tags')
                                }
                            }
                        })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tab-container {
        width: calc(100vw - 750px);
        .is-collapsed & {
            width: calc(100vw - 450px);
        }
    }
    .lower-scroll {
        overflow: auto;
        width: 100%;
        height: 100%;
    }
    .left-col {
        width: 250px;
        border-right: solid 1px #ECEDF1;
    }
    .col-header {
        height: 60px;
        overflow: hidden;
        border-bottom: solid 1px #ECEDF1;
        .fe-tabs-main {
            position: relative;
            z-index: 5;
            top: 7px;
        }
    }
    .selected-student { background-color: rgba(0, 108, 144, 0.2); }
    .meeting-students-main {
        border: 1px solid #ECEDF1; 
        border-radius: 4px;
    }
    .meetings-student-list-filter {
        ::v-deep .v-input__slot {
            border: none !important;
            height: 55px;
        }
    }
    .filter-field {
        width: 250px;
    }
    .meeting-tabs {
        flex: 1;
        max-width: calc(100% - 250px);
    }
</style>
